import React, { useState } from 'react';

function TagInput({ tags = [], onChange }) {
  const [internalTags, setInternalTags] = useState(tags);
  const [inputValue, setInputValue] = useState('');

  const isControlled = typeof onChange === 'function';
  const currentTags = isControlled ? tags : internalTags;

  const addTag = (newTag) => {
    if (!currentTags.includes(newTag)) {
      const updatedTags = [...currentTags, newTag];
      if (isControlled) {
        onChange(updatedTags);
      } else {
        setInternalTags(updatedTags);
      }
    }
  };

  const removeTag = (tagToRemove) => {
    const updatedTags = currentTags.filter((tag) => tag !== tagToRemove);
    if (isControlled) {
      onChange(updatedTags);
    } else {
      setInternalTags(updatedTags);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      e.preventDefault();
      addTag(inputValue.trim());
      setInputValue('');
    }
  };

  return (
    <div
      className='choices w-100'
      data-type='text'
      aria-haspopup='true'
      aria-expanded='false'
    >
      <div className='choices__inner'>
        {/* Hidden input for compatibility */}
        <input
          className='form-control choices__input'
          id='choices-text-remove-button'
          type='text'
          hidden
          tabIndex='-1'
          data-choice='active'
        />

        {/* Display added tags */}
        <div className='choices__list choices__list--multiple'>
          {currentTags.map((tag, index) => (
            <div key={index} className='choices__item'>
              {tag}
              <button
                type='button'
                className='close-button'
                onClick={() => removeTag(tag)}
              >
                &times;
              </button>
            </div>
          ))}
        </div>

        {/* Input field for new tags */}
        <input
          type='text'
          className='choices__input choices__input--cloned'
          autoComplete='off'
          autoCapitalize='off'
          spellCheck='false'
          placeholder='Type Tag and press Enter'
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      <style>{`
        .choices {
          border-radius: 0.375rem;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          position: relative;
          width: 100%;
          min-height: 3.5rem;
        }
        .choices__inner {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          flex: 1;
          min-height: 3.5rem;
        }
        .choices__list--multiple {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        .choices__item {
          background-color: #007bff;
          color: white;
          padding: 0.25rem 0.5rem;
          border-radius: 0.375rem;
          display: flex;
          align-items: center;
        }
        .choices__item .close-button {
          background: none;
          border: none;
          color: white;
          margin-left: 0.5rem;
          font-size: 1rem;
          cursor: pointer;
        }
        .choices__input--cloned {
          border: none;
          outline: none;
          flex-grow: 1;
          font-size: 0.8rem;
          width: 100%;
        }
        .choices__input--cloned::placeholder {
          color: #6c757d;
        }
      `}</style>
    </div>
  );
}

export default TagInput;
